module.exports = __webpack_public_path__ + "img/showcase_green.58f69523.png";